import { bindLog, LogSender } from '@servicetitan/log-service';
import { rootContainer } from '@servicetitan/react-ioc';

bindLog(rootContainer);
rootContainer.get(LogSender);
